export default "__VITE_ASSET__fea3e7ba__"